<form [formGroup]="form" NfFormValidation (validSubmit)="onSubmit()">
  <div class="modal-header" hsDraggable="modal-dialog">
    <h4 class="modal-title">{{ modalTitle }}</h4>
    <button
      nf-icon-button="cancel"
      icon="close"
      class="btn-bare"
      ngbTooltip="Close"
      (click)="onCancel()"
    ></button>
  </div>

  <div class="modal-body" hsDraggable="modal-dialog">
    <div class="form-row">
      <nf-form-control class="form-group col-6" compact>
        <label class="field-title" for="issueNameInput">Issue Name*</label>
        <input
          nfAutofocus
          id="issueNameInput"
          class="form-control"
          [formControl]="issueName"
          type="text"
          required
        />
      </nf-form-control>

      <nf-form-control class="form-group col-6" compact>
        <label class="field-title" for="accountIdInput">Account ID</label>
        <input
          id="accountIdInput"
          class="form-control"
          [formControl]="accountId"
          type="number"
          min="1"
        />
      </nf-form-control>
    </div>

    <div class="form-row">
      <nf-form-control class="form-group col-6" compact>
        <label class="field-title" for="securityIdInput"
          >Security Identifier*</label
        >
        <input
          class="form-control"
          id="securityIdInput"
          [formControl]="securityId"
          type="text"
          required
        />
      </nf-form-control>

      <nf-form-control class="form-group col-6" compact>
        <label class="field-title" for="tickerInput">Ticker</label>
        <input
          class="form-control"
          id="tickerInput"
          [formControl]="ticker"
          type="text"
        />
      </nf-form-control>
    </div>

    <div class="form-row">
      <nf-form-control class="form-group col-4" compact>
        <label class="field-title" for="beginDate">Begin Date*</label>
        <nf-datepicker
          id="beginDate"
          [formControl]="beginDate"
          [format]="dateFormat"
        ></nf-datepicker>
      </nf-form-control>

      <nf-form-control class="form-group col-4" compact>
        <label class="field-title" for="clearwaterValue"
          >Clearwater Value</label
        >
        <input
          class="form-control"
          id="clearwaterValue"
          [formControl]="clearwaterValue"
          type="text"
        />
      </nf-form-control>

      <nf-form-control class="form-group col-4" compact>
        <label class="field-title" for="clientValue">Client Value</label>
        <input
          class="form-control"
          id="clientValue"
          [formControl]="clientValue"
          type="text"
        />
      </nf-form-control>
    </div>

    <div class="form-row">
      <nf-form-control class="form-group col-6" compact>
        <label class="field-title" for="issueType">Issue Type*</label>
        <ng-select
          placeholder="Select Issue Type..."
          bindLabel="name"
          [items]="issueTypeOptions"
          id="issueType"
          [formControl]="issueType"
          [loading]="loadingOptions"
        >
        </ng-select>
      </nf-form-control>

      <nf-form-control class="form-group col-6" compact>
        <label class="field-title" for="issueSource">Issue Source*</label>
        <ng-select
          placeholder="Select Issue Source..."
          bindLabel="name"
          [items]="issueSourceOptions"
          id="issueSource"
          [formControl]="issueSource"
          [loading]="loadingOptions"
        >
        </ng-select>
      </nf-form-control>
    </div>

    <div class="form-row">
      <nf-form-control class="form-group col-6" compact>
        <label class="field-title" for="priority">Priority*</label>
        <ng-select
          placeholder="Select Priority..."
          bindLabel="name"
          [items]="priorityOptions"
          id="priority"
          [formControl]="priority"
          [loading]="loadingOptions"
        >
        </ng-select>
      </nf-form-control>

      <nf-form-control class="form-group col-6" compact>
        <label class="field-title" for="assignee">Assignee*</label>
        <ng-select
          placeholder="Select Assignee..."
          bindLabel="fullname"
          [items]="assigneeOptions"
          id="assignee"
          [formControl]="assignee"
          [loading]="loadingOptions"
        >
        </ng-select>
      </nf-form-control>
    </div>

    <label class="field-title">Attachments</label><br />
    <nf-file-select [formControl]="selectedFiles"></nf-file-select>

    <nf-form-control compact>
      <label class="field-title" for="description">Description</label>
      <textarea
        *nfLoader="loadingOptions"
        class="form-control"
        id="description"
        [formControl]="description"
        type="text"
        rows="4"
      >
      </textarea>
    </nf-form-control>
  </div>

  <div class="modal-footer" hsDraggable="modal-dialog">
    <button nf-button="cancel" (click)="onCancel()"></button>
    <button
      nf-button="submit"
      [disabled]="form.invalid"
      [loading]="formSubmitting"
    >
      {{ saveBtnLabel }}
    </button>
  </div>
</form>
